/**
 * Content-only slide for Menti participants.
 * Displays title and description with no input needed.
 *
 * @param {Object} props
 * @param {Object} props.slide - Slide data with title and description
 */
export default function ContentSlide({ slide }) {
  return (
    <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-8 border border-white/15 text-center">
      {slide.title && (
        <h2 className="text-white text-2xl md:text-3xl font-bold mb-4">
          {slide.title}
        </h2>
      )}

      {slide.description && (
        <p className="text-white/80 text-lg leading-relaxed">
          {slide.description}
        </p>
      )}

      {/* Waiting indicator */}
      <div className="mt-8 flex flex-col items-center gap-3">
        <div className="flex items-center gap-1.5">
          <span className="w-2 h-2 bg-blue-300/60 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
          <span className="w-2 h-2 bg-blue-300/60 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
          <span className="w-2 h-2 bg-blue-300/60 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
        </div>
        <p className="text-white/50 text-sm">
          Ventar på neste lysbilde...
        </p>
      </div>
    </div>
  );
}
